module.exports = __webpack_public_path__ + "img/discord.8ff80fa1.svg";